//
//Login Service is a special one and it does not follow the pattern as the others do
//
import { loginUrl, restaurantOwnerProfilesUrl } from './resources.js'
import Axios from 'axios'

async function authenticate(credentials) {
    let response = await Axios.post(`${loginUrl}`, credentials)
                                  .catch((err) => {console.log(err)});
    if (response.data.success == true) {
        let profile = await Axios.create({
            headers: {
                "Authorization": `Bearer ${response.data.token}`
            }})
            .get(`${restaurantOwnerProfilesUrl}/${credentials.username}`);

        response.data.restaurantOwnerId = profile.data.restaurantOwnerId;
        response.data.restaurantOwnerName = profile.data.restaurantOwnerName;
        response.data.phoneNumber = profile.data.phoneNumber;
    }
    return response.data;
}

export default {
    name: 'loginService',
    authenticate
} 
